// firebaseConfig.js

import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  RecaptchaVerifier,
  getIdToken,
  signInWithPhoneNumber,
  signOut,
  initializeAuth,
  signInWithCredential,
  indexedDBLocalPersistence,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword,
  EmailAuthProvider,
  onAuthStateChanged,
} from 'firebase/auth';

import { FirebaseAuthentication } from '@capacitor-firebase/authentication';

import {
  Timestamp,
  collection,
  doc,
  updateDoc,
  deleteDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  getCountFromServer,
  orderBy,
  getFirestore,
  limit
} from 'firebase/firestore';

const config = {
  apiKey: import.meta.env.VITE_GOOGLE_APIKEY,
  authDomain: import.meta.env.VITE_GOOGLE_AUTHDOMAIN,
  projectId: import.meta.env.VITE_GOOGLE_PROJECTID,
  storageBucket: import.meta.env.VITE_GOOGLE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_GOOGLE_MESSAGINGSENDERID,
  appId: import.meta.env.VITE_GOOGLE_APPID,
  measurementId: import.meta.env.VITE_GOOGLE_MEASUREMENTID,
};

const app = initializeApp(config);

const firestore = getFirestore(app);
// const firestore = initializeFirestore(app, {
//   localCache: persistentLocalCache({
//     tabManager: persistentSingleTabManager(),
//     cacheSizeBytes: CACHE_SIZE_UNLIMITED,
//     synchronizeTabs: true,
//   }),
// });

let auth;

if (Capacitor.isNativePlatform()) {
  auth = initializeAuth(app, {
    persistence: indexedDBLocalPersistence,
  });
} else {
  auth = getAuth(app);
  auth.settings.appVerificationDisabledForTesting = false;
}

export {
  FirebaseAuthentication, // Capacitor
  RecaptchaVerifier,
  getIdToken,
  signInWithPhoneNumber,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  auth, // getAuth
  signInWithCredential,
  EmailAuthProvider,
  onAuthStateChanged,
  signOut,
  firestore,
  Timestamp,
  collection,
  doc,
  getCountFromServer,
  updateDoc,
  getDocs,
  deleteDoc,
  query,
  where,
  onSnapshot,
  orderBy,
  limit
};
